import React from "react";
import Data from './Data';
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { BsPen } from "react-icons/bs";
import InstagramIcon from '../../components/Icons/Instagram';
import PageHeader, { PageParagraph } from '../../components/Headers/Pageheaders';
import EmailIcon from '../../components/Icons/Email';
import './styles.css';

export default function FAQ() {
  const PageDescription = 'For any additional queries please feel free to reach out to me via Email or Instagram';

  return (
    <>
      <section className="wedding-header">
        <PageHeader title="Terms and Conditions" />
        <PageParagraph
          text={PageDescription}
          endIcon={
            <>
              <EmailIcon />
              <InstagramIcon />
            </>
          }
        />
        <div className="faq-grid">
          {Data?.map((FAQ, k) => (
            <div className="faq-card" key={k}>
              <div className="faq-card-inner">
                <h5 className="faq-question">
                  <AiOutlineQuestionCircle  className="faq-icon" />
                  {FAQ?.question}
                </h5>
                <p className="faq-answer">
                  <BsPen  className="faq-icon" />
                  {FAQ?.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}